// Types
import { Set } from '@globalTypes/store';
import { ResetPasswordState } from './useResetPasswordStore.types';
// Utils
import { resetPasswordWaitTime } from '@constants/index';

/**
 * Action for setting the time to next try timestamp fo a user
 * @param {string} username - The username of the new user to be added.
 * @returns void
 */
const setUserNextTry =
  (set: Set<ResetPasswordState>) =>
  (username: string, timeToNextTry = resetPasswordWaitTime * 1000) =>
    set((state) => {
      state.usersTimeToNextTry[username] = Date.now() + timeToNextTry;
    });

/**
 * Returns an object containing actions related to the reset password functionality.
 * @param set - The state setter function for the reset password state.
 * @returns An object with actions to perform reset password operations.
 */
export const resetPasswordActions = (set: Set<ResetPasswordState>) => ({
  setUserNextTry: setUserNextTry(set),
});
